import { h, Component } from 'preact';

import Header from '../Header';

export default class Page extends Component {
	render() {
		return (
			<div>

				{
					this.props.hideNavBar
					? ''
					: <Header />
				}

				<div class="page">

					<div>
						<h1>{this.props.header}</h1>
					</div>

					<div>
						{this.props.children}
					</div>

				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./components/Page/index.js